(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'homeBranch'
        })
        
        .controller('ManageHomeBranchController', ManageHomeBranchController);

        ManageHomeBranchController.$inject = ['$scope', '$state', 'workflowSharedService', 'ManageHomeBranch', 'GlobalValues', 'EntityPermissions','ScreenLog','$rootScope','entityConstants','$timeout', 'AlertService', '$filter', ];

    function ManageHomeBranchController($scope, $state, workflowSharedService, ManageHomeBranch, GlobalValues, EntityPermissions,ScreenLog,$rootScope,entityConstants,$timeout,AlertService,$filter) {
        
        var vm = this;
        
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_HOME_BRANCH;
        $scope.refresh=refresh;
        workflowSharedService.viewFrom = "homeBranch";
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.launch=launch;
        vm.clicked=false;
        vm.orgid=vm.globalValues.getOrganisation();
        vm.exportDataToFile = exportDataToFile;
        vm.manageHomeBranchfileName = "Manage_Home_Branch_Report_";
        vm.fileName = vm.manageHomeBranchfileName;
        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
        vm.generateHomeBranchExcel = generateHomeBranchExcel;

        function launch() {
        	$state.go('home-branch');
        }
        
        vm.permitHomeBranchViewEntityAction = EntityPermissions.hasPermission('ManageHomeBranch.VIEW')
        vm.permitHomeBranchEditEntityAction = EntityPermissions.hasPermission('ManageHomeBranch.EDIT')
        vm.permitHomeBranchCreateEntityAction = EntityPermissions.hasPermission('ManageHomeBranch.CREATE')
		vm.permitHomeBranchDeleteEntityAction = EntityPermissions.hasPermission('ManageHomeBranch.DELETE')
 
		console.log(vm.permitHomeBranchViewEntityAction);
		if(vm.permitHomeBranchViewEntityAction){
			loadAll();	
		}
        
		function loadAll(){
            // if(vm.entityOwnerType=='Clearcorp'){
            //     vm.bankId=vm.bank.id;
            //     ManageHomeBranch.getAllHomeBranchesForBank({bankId: vm.globalValues.getOrganisation().id}, function(result) {
            //         vm.homeBranch = result;
            //         vm.clicked=false;                    
            //     });	
            // }else
			ManageHomeBranch.getAllHomeBranchesForBank({bankId: vm.globalValues.getOrganisation().id}, function(result) {
                vm.homeBranch = result;
                vm.clicked=false;                    
            });	
		}
		logScreenAccess();
        vm.loadAll = function loadAll(bank) {
        	vm.bankId = 0;
        		if(bank!=null && bank!=undefined){
            		vm.bankId = bank.id;
        		}
        		ManageHomeBranch.getAllHomeBranchesForBank({bankId: vm.bankId}, function(result) {
                    vm.homeBranch = result;
                    vm.clicked=false;            
                });

        	if(bank != undefined){vm.bankId = bank.id};
        	console.log(vm.bankId);   	
            
        }
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
        function exportDataToFile(fileType){
            if(vm.bank == null  || vm.bank == undefined){
                vm.bankId=vm.globalValues.getOrganisation().id;
            }else{
                vm.bankId=vm.bank.id;
            }
			vm.fileName =  vm.manageHomeBranchfileName;
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					ManageHomeBranch.exportHomeBranchCsv({bankId:vm.bankId}, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					ManageHomeBranch.exportHomeBranchExcel({bankId:vm.bankId},processResponse );
				}
		}

		function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}

    function generateHomeBranchExcel() {
    ManageHomeBranch.exportHomeBranchDetails(function (response) {
        var message = $filter('translate')('gatewayApp.homeBranch.GeneratingExcel');
        AlertService.success(message);
    }, function (error) {
        var errorMessage = $filter('translate')('gatewayApp.homeBranch.errorGeneratingExcel');
        AlertService.error(errorMessage);
        console.error(error);
    });
}

      
    }
})();
